import axios from "axios";
import { authHeader } from "./auth-header";

const getAllCountries = async () => {
  return axios.get(process.env.REACT_APP_API_URL + `countries/list`, {
    headers: authHeader()
  });
};

const getAllStates = async (countryId) => {
  return axios.get(process.env.REACT_APP_API_URL + `states/list/${countryId}`, {
    headers: authHeader()
  });
};

const getAllCities = async () => {
  return axios.get(process.env.REACT_APP_API_URL + `cities/list`, {
    headers: authHeader()
  });
};

const getVerifyAddress = async (zipCode) => {
  return axios.post(process.env.REACT_APP_API_URL + `verifyAddress`, { zipCode: zipCode }, {
    headers: authHeader()
  });
};


export default { 
    getAllCountries,
    getAllStates,
    getAllCities,
    getVerifyAddress,
};
